import {
  SET_EMPLOYERS_AND_ROLES,
  SET_EMPLOYER_DIALOG,
  SET_EMPLOYER_CODE,
  SET_EMPLOYER_CNPJ,
  SET_EMPLOYER_SOCIAL_NAME,
  SET_EMPLOYER_CONTACTS,
} from '../../mutation-types';

const mutations = {
  [SET_EMPLOYERS_AND_ROLES](state, employerAndRoleList) {
    state.employersAndRoleList.splice(
      0,
      state.employersAndRoleList.length,
      ...employerAndRoleList,
    );
  },
  [SET_EMPLOYER_DIALOG](state, params) {
    state.employerDialog.status = params.status;
    state.employerDialog.action = params.action;
  },
  [SET_EMPLOYER_CODE](state, code) {
    state.employerCode = code;
  },
  [SET_EMPLOYER_CNPJ](state, CNPJ) {
    state.employerCnpj = CNPJ;
  },
  [SET_EMPLOYER_SOCIAL_NAME](state, socialName) {
    state.employerSocialName = socialName;
  },
  [SET_EMPLOYER_CONTACTS](state, contacts) {
    state.employerContacts = contacts;
  },
};

export default mutations;
